import { ArticleShell } from './ArticleShell';
import { SourcesBlock } from './SourcesBlock';
export function StressAndSleep() {
    return (
        <>
            <ArticleShell>
                <h1 className="mb-20 text-mobile-display-2">
                    Sover du dårligt?
                </h1>

                <p className="mb-20 text-body">
                    Har du oplevet, at du er helt udmattet, men alligevel ikke
                    kan falde i søvn? Eller at du vågner flere gange i løbet af
                    natten med tankerne kørende? Det er en oplevelse, mange har,
                    når de er stressede. Stress og søvn påvirker nemlig hinanden
                    gensidigt: Når vi er stressede, bliver det sværere at sove,
                    og når vi sover dårligt, bliver vi ofte mere sårbare over
                    for stress dagen efter.
                </p>

                <p className="mb-20 text-body">
                    Den gode nyhed er, at små ændringer i dine vaner kan hjælpe
                    kroppen med at falde til ro. Du behøver ikke gøre det hele
                    på én gang – vælg et par ting, der virker realistiske for
                    dig.
                </p>

                <div className="my-20">
                    <img
                        src="/images/articleIllustrations/StressAndSleepIllustration1.png"
                        alt="Stress and sleep illustration"
                        className="w-full rounded-[10px]"
                    />
                </div>

                <h2 className="mb-20 text-mobile-display-1">
                    Skab gode søvnvaner
                </h2>

                <p className="mb-20 text-body">
                    Når kroppen er stresset, kan den have svært ved at skifte
                    fra aktivitet til hvile. Derfor kan det hjælpe at gøre
                    aftenen så rolig og forudsigelig som muligt.
                </p>

                <p className="mb-20 text-body">
                    Det kan være en god idé at begrænse kaffe, energidrikke og
                    andre koffeinholdige drikke sidst på dagen. Alkohol kan
                    måske gøre dig søvnig, men den forringer ofte søvnkvaliteten
                    og giver flere opvågninger i løbet af natten. Regelmæssig
                    motion i løbet af dagen kan derimod gøre det lettere at
                    falde i søvn om aftenen.
                </p>

                <h2 className="mb-20 text-mobile-display-1">
                    Gør soveværelset til et sted for ro
                </h2>

                <p className="mb-20 text-body">
                    Dine omgivelser har også betydning for søvnen. Et mørkt,
                    stille og køligt soveværelse giver kroppen de bedste
                    betingelser for at slappe af. Prøv også at lægge telefon,
                    computer og tablet væk den sidste time før sengetid. Lyset
                    fra skærme kan gøre det sværere for hjernen at forstå, at
                    det er tid til at sove.
                </p>

                <p className="mb-20 text-body">
                    Hvis du ofte ligger vågen, kan det også være en hjælp kun at
                    bruge sengen til søvn og ikke til arbejde, mails eller
                    sociale medier. På den måde lærer hjernen igen at forbinde
                    sengen med hvile.
                </p>

                <h2 className="mb-20 text-mobile-display-1">
                    Når tankerne fylder
                </h2>

                <p className="mb-20 text-body">
                    For mange er det ikke kroppen, men tankerne, der holder dem
                    vågne. Bekymringer om dagen, morgendagens opgaver eller
                    tanker om, hvor vigtigt det er at sove, kan gøre det endnu
                    sværere at falde til ro.
                </p>

                <p className="mb-20 text-body">
                    Hvis du oplever tankemylder, kan du prøve at skrive dine
                    bekymringer ned inden sengetid eller lave en kort
                    afspændingsøvelse. Det vigtigste er ikke at fjerne alle
                    tanker, men at hjælpe kroppen med at falde til ro. Husk
                    også, at en enkelt dårlig nat sjældent ødelægger dagen efter
                    – bekymringen om ikke at sove kan nogle gange være mere
                    forstyrrende end søvnmanglen i sig selv.
                </p>

                <h2 className="mb-20 text-mobile-display-1">
                    Små skridt er nok
                </h2>

                <p className="mb-20 text-body">
                    Når man er stresset, kan det være uoverskueligt at ændre en
                    masse vaner på én gang. Start derfor med 2-3 ting, som
                    virker realistiske i din hverdag. Det kan for eksempel være
                    en fast sengetid, mindre koffein om eftermiddagen eller en
                    rolig aftenrutine uden skærm.
                </p>

                <p className="mb-20 text-body">
                    Små ændringer kan over tid gøre en stor forskel. Bedre søvn
                    giver kroppen bedre mulighed for at restituere, og det kan
                    gøre dig mere robust, når hverdagen er presset.
                </p>
            </ArticleShell>

            <SourcesBlock
                sources={[
                    'Sundhedsstyrelsen: https://www.sst.dk/vidensbase/forebyggelse/anbefalinger-for-soevnlaengde',
                ]}
            />
        </>
    );
}
